function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 29.999 29.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    width: 29.999,
    height: 29.999,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,5h29.999v19.999H0V5Z",
    style: {
      fill: "#002b7f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,17.499h29.999v2.5H0v-2.5Z",
    style: {
      fill: "#f9e814"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "7.474 11.928 8.78 10.98 7.166 10.98 6.667 9.444 6.167 10.98 4.553 10.98 5.859 11.928 5.36 13.464 6.666 12.515 7.973 13.464 7.474 11.928",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "3.939 8.53 4.918 7.818 3.707 7.818 3.333 6.667 2.959 7.818 1.748 7.818 2.728 8.53 2.354 9.682 3.333 8.97 4.313 9.682 3.939 8.53",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCw);
export default __webpack_public_path__ + "static/media/CW.6ad8a2caf37e6aabe19ccd7d10f2bcf2.svg";
export { ForwardRef as ReactComponent };